// extracted by mini-css-extract-plugin
export default {"container":"pchVg","info":"QAdoM","block":"VZdEv"};